/* eslint-disable jest/require-hook */
/* eslint-disable no-useless-return */

const TeamTabsWrapperUtils = {
  offsets: { desktop: 167, mobile: 84 },
  init: () => {
    const tabsWrapper: NodeListOf<Element> | [] = document.querySelectorAll('.ftbl__team-tabs-wrapper');

    if (tabsWrapper?.length) {
      tabsWrapper?.forEach((wrapper) => {
        TeamTabsWrapperUtils.handleEvents(wrapper);
      });
    }
  },
  handleEvents: (wrapper: Element) => {
    wrapper.querySelectorAll('.ftbl__team-tabs-wrapper__footer-button').forEach((tabButton) => {
      tabButton.addEventListener('click', (e) => {
        const top = TeamTabsWrapperUtils.getWrapperTop(wrapper);
        TeamTabsWrapperUtils.scrollToTop(top);
      });
    });
  },
  getWrapperTop: (wrapper: Element) => {
    return wrapper.getBoundingClientRect().top + window.scrollY;
  },
  scrollToTop: (top: number) => {
    const stickyVideo = document.querySelector('.c-hero__media-wrapper--sticky-player');
    const stickyVideoHeight = stickyVideo?.getBoundingClientRect().height || 0;

    const offset =
      window.innerWidth > 1024
        ? TeamTabsWrapperUtils.offsets.desktop
        : TeamTabsWrapperUtils.offsets.mobile + stickyVideoHeight;

    window.scrollTo(0, top - offset);
  },
};

Object.freeze(TeamTabsWrapperUtils);

export default TeamTabsWrapperUtils;
